<template>
  <div id="app">
    <a-layout class="layout">
      <a-layout-header>
        <img class="logo" src="./assets/logo.png" @click="redirect('/')" :title="$t('title')" />
        <a-menu mode="horizontal" :selectable="false" :style="{ lineHeight: '62px' }">
          <a-menu-item
            :class="$route.path === '/login'? 'ant-menu-item-selected' : ''"
            key="login"
            v-if="!isAuth"
            @click="redirect('/login')"
          >{{$t('login')}}</a-menu-item>
          <a-menu-item
            :class="$route.path === '/signup'? 'ant-menu-item-selected' : ''"
            key="signup"
            v-if="!isAuth"
            @click="redirect('/signup')"
          >{{$t('signup')}}</a-menu-item>
          <a-menu-item
            :class="$route.path === '/settings'? 'ant-menu-item-selected' : ''"
            key="settings"
            v-if="!!isAuth"
            @click="redirect('/settings')"
          >{{$t('settings')}}</a-menu-item>
          <a-menu-item
            :class="$route.path === '/logout'? 'ant-menu-item-selected' : ''"
            key="logout"
            v-if="!!isAuth"
            @click="logout()"
          >{{$t('logout')}}</a-menu-item>
        </a-menu>
      </a-layout-header>
      <a-layout-content>
        <div class="container">
          <a-alert
            class="banner"
            v-if="($route.path !== '/settings' && $route.path !== '/login' && $route.path !== '/signup') && !!user && (!user.hasConfigured.categories || !user.hasConfigured.currencies || !user.hasConfigured.tags)"
            message="Finish your setup"
            type="warning"
            showIcon
          >
            <div slot="description">
              Before you proceed using the application, Please update your configurations
              <a-button type="link" style="padding:0px;" @click="redirect('/settings')">here</a-button>.
            </div>
          </a-alert>
          <router-view></router-view>
        </div>
      </a-layout-content>
      <!-- <a-layout-footer style="text-align: center">Wallet ©2020 Created by hem</a-layout-footer> -->
    </a-layout>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import fb from "./firebaseConfig.js";
import { USER_INFO, IS_AUTHENTICATED } from "./store/constants";

export default {
  name: "app",
  computed: {
    ...mapState({
      isAuth: state => state.auth[IS_AUTHENTICATED],
      user: state => state.auth[USER_INFO]
    })
  },
  methods: {
    ...mapActions({
      logout: "auth/logout"
    }),
    // async data() {
    //   const snapshot = await fb.categories.get();
    //   return snapshot.docs.map(doc => console.log(doc.data()));
    // }
    redirect(d) {
      this.$router.push(d);
    }
    // logout() {
    //   this.$store.dispatch("auth/logout", this.$router);
    // }
  }
};
</script>

<style lang="less">
@import "./styles/variables.less";

.logo {
  height: 42px;
  margin: auto 0;
}
.ant-layout-header {
  display: flex;
  justify-content: space-between;
  padding: 0 32px;
  background: rgba(255, 255, 255, 0.5);
  box-shadow: 0 1px rgba(0, 0, 0, 0.1);
  .ant-menu-horizontal {
    background: transparent;
    border-bottom: none;
  }
}
.ant-layout-content {
  min-height: ~"calc(100vh - 64px)";
  background: transparent;
  padding-top: 16px;
}
// .ant-layout-footer {
//   height: 64px;
//   display: flex;
//   justify-content: center;
//   align-items: center;
//   background: rgba(255, 255, 255, 0.5);
//   box-shadow: 0 -1px rgba(0, 0, 0, 0.1);
// }
.container {
  width: 100%;
  max-width: 1024px;
  padding: 0 8px;
  margin: 0 auto;
}
.banner {
  margin-bottom: @spacing*2;
}
</style>
